module.exports = __webpack_public_path__ + "img/gift6.7dba82b9.png";